import { UnitConverter } from '../base/UnitConverter';
import { UnitOptions } from '../constants/unit.options';

export class DecimalBytesUnitConverter extends UnitConverter<
  (typeof UnitOptions)['Bytes(decimal)'][number]['value']
> {
  // 싱글턴 인스턴스
  private static instance: DecimalBytesUnitConverter;

  private constructor() {
    super();
  }

  static getInstance(): DecimalBytesUnitConverter {
    if (!DecimalBytesUnitConverter.instance) {
      DecimalBytesUnitConverter.instance = new DecimalBytesUnitConverter();
    }
    return DecimalBytesUnitConverter.instance;
  }

  protected units = [
    'bit (b) - Bytes(decimal)',
    'byte (B) - Bytes(decimal)',
    'kilobyte (KB)',
    'megabyte (MB)',
    'gigabyte (GB)',
    'terabyte (TB)',
    'petabyte (PB)',
    'exabyte (EB)',
  ] as const;

  protected unitToBase = {
    'bit (b) - Bytes(decimal)': 1,
    'byte (B) - Bytes(decimal)': 8,
    'kilobyte (KB)': 8 * 1_000,
    'megabyte (MB)': 8 * 1_000_000,
    'gigabyte (GB)': 8 * 1_000_000_000,
    'terabyte (TB)': 8 * 1_000_000_000_000,
    'petabyte (PB)': 8 * 1_000_000_000_000_000,
    'exabyte (EB)': 8 * 1_000_000_000_000_000_000,
  };
}
